import { createContext } from 'react';

export const CurrentUserContext = createContext({});

export const CurrentUserProvider = CurrentUserContext.Provider;
export const CurrentUserConsumer = CurrentUserContext.Consumer;
